import ClockIcon from "../../../icons/ClockIcon";
import React from "react";

interface props {
  title?: string;
  message?: string;
}
export const EmptyListFallback = ({ title, message }: props) => {
  return (
    <div className="flex flex-col items-center h-full justify-center p-8 bg-white rounded-2xl shadow-md border border-gray-100 text-center animate-fadeIn">
      <div className="bg-gray-100 p-4 rounded-full mb-6">
        <ClockIcon />
      </div>
      <h2 className="text-xl font-semibold text-gray-700 mb-2">
        {title ? title : "No Data Found"}
      </h2>
      <p className="text-gray-500 mb-4">
        {message
          ? message
          : `We couldn't find anything to show here at the moment.`}
      </p>
    </div>
  );
};
